import { useConfirm, useLoading } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { useBatchTicketActions } from '../../../store/batchTicket/actions';
import {
  basketAdvisorOrderIdState,
  customerCartState,
  customerCartStatusState,
  productsCartStatusState,
} from '../../../store/batchTicket/atom';
import {
  customerCartCountSelector,
  customerCartTotalAvailableBalanceSelector,
} from '../../../store/batchTicket/selectors';

export const useCustomersAdded = () => {
  const { cleanCustomersCart, onChangeCustomerCartStatus } = useBatchTicketActions();
  const { canGoBack, goBack } = useNavigation();
  const { hide, show } = useLoading();

  const customerCartCount = useRecoilValue(customerCartCountSelector);
  const customerCartItems = useRecoilValue(customerCartState);
  const customerCartTotalAvailableBalance = useRecoilValue(
    customerCartTotalAvailableBalanceSelector
  );
  const basketAdvisorOrderId = useRecoilValue(basketAdvisorOrderIdState);

  const resetCustomerCartStatus = useResetRecoilState(customerCartStatusState);
  const resetProductsCartStatus = useResetRecoilState(productsCartStatusState);

  const resetCustomerCart = async () => {
    show({
      title: 'Aguarde estamos limpando sua cesta.',
      description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
    });
    await cleanCustomersCart(basketAdvisorOrderId);
    resetCustomerCartStatus();
    resetProductsCartStatus();
    hide();
  };
  const { confirm } = useConfirm();
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const customerCartIsEmpty = customerCartCount === 0;

  const handleResetCustomerCart = () => {
    confirm(
      {
        isMobile,
        title: 'Atenção',
        description:
          'Está ação limpará os dados salvos até o momento.\nDeseja continuar mesmo assim?',
        icon: 'Warning',
        confirmText: 'Continuar',
        confirmColor: 'feedback.error.default',
      },
      resetCustomerCart
    );
  };

  const handleGoBack = useCallback(() => {
    if (canGoBack()) {
      goBack();
    }
  }, [canGoBack, goBack]);

  const handleAddCustomers = () => {
    onChangeCustomerCartStatus('start');
    handleGoBack();
  };

  return {
    customerCartItems,
    customerCartTotalAvailableBalance,
    resetCustomerCart: handleResetCustomerCart,
    customerCartIsEmpty,
    customerCartCount,
    handleAddCustomers,
  };
};
